// src/setTimeoutEx.ts
import { assertEx } from "@xylabs/assert";
var timeouts = [];
var currentTimeout;
var interval = -1;
var reset = () => {
  interval = -1;
  clearTimeout(currentTimeout);
  currentTimeout = void 0;
  timeouts = [];
};
var update = (newTimeouts = timeouts, delayPassed = 0) => {
  if (newTimeouts.length <= 0) {
    reset();
  } else {
    const newInterval = Math.min(...newTimeouts.map((timeout) => timeout.delay));
    if (newInterval === interval && currentTimeout !== void 0) {
      return;
    } else {
      clearTimeout(currentTimeout);
      timeouts = newTimeouts.map((timeout) => ({
        delay: timeout.delay - delayPassed,
        func: timeout.func,
        id: timeout.id
      }));
      interval = newInterval;
      currentTimeout = setTimeout(timerFunc, interval);
    }
  }
};
var timerFunc = () => {
  const notFiring = timeouts.filter((timeout) => timeout.delay > interval);
  const firing = timeouts.filter((timeout) => timeout.delay <= interval);
  update(notFiring, interval);
  for (const timeout of firing) {
    timeout.func();
  }
};
var setTimeoutEx = (func, delay) => {
  assertEx(delay >= 0, () => "delay must be >= 0");
  const id = `${Date.now()}|${Math.random() * 9999999999}`;
  timeouts.push({
    delay,
    func,
    id
  });
  update();
  return id;
};
var clearTimeoutEx = (id) => {
  timeouts = timeouts.filter((timeout) => timeout.id !== id);
  update(timeouts);
};
export {
  clearTimeoutEx,
  setTimeoutEx
};
//# sourceMappingURL=index.mjs.map